import { ICustomerInfo } from "@wff/interfaces";

interface IYotpoSwellCustomerIdentification {
  customerInfo: ICustomerInfo;
}

const YotpoSwellCustomerIdentification = (
  customer: IYotpoSwellCustomerIdentification
) => {
  const { email, member } = customer?.customerInfo;
  const isMember = member ? "member" : "";

  return (
    <>
      <div
        id="swell-customer-identification"
        data-authenticated="true"
        data-email={email} // email
        data-id={email} // customer ID
        data-tags={isMember ? `['${isMember}']` : ""} // if member else empty
        style={{ display: "none" }}
      ></div>
    </>
  );
};

export default YotpoSwellCustomerIdentification;
